export const OIG_CHECKS_ADDON_KEY = 'oig_checks';

export function buildBillingAddonPurchaseSuccessUrl(addonId: string | number): string {
  const params = new URLSearchParams({
    tab: 'addons',
    addon: String(addonId),
    oigAddon: '1',
  });
  // Stripe substitutes the literal {CHECKOUT_SESSION_ID} placeholder on redirect.
  return `${window.location.origin}/dashboard/billing?${params.toString()}&session_id={CHECKOUT_SESSION_ID}`;
}

export function buildBillingAddonsUrl(addonId?: string | number): string {
  const params = new URLSearchParams({ tab: 'addons' });
  if (addonId != null && addonId !== '') {
    params.set('addon', String(addonId));
  }
  return `/dashboard/billing?${params.toString()}`;
}
